import { PORTALS_SURFACE_TOKENS, PORTALS_PRIMARY_COLOR_TOKENS, PORTALS_SECONDARY_COLOR_TOKENS, PORTALS_ACCENT_COLOR_ONE_TOKENS, PORTALS_HEADING_FONT_TOKENS, PORTALS_BODY_FONT_TOKENS } from 'portals-platform-lib';
export const surfaceSection = {
  id: 'surface',
  title: 'Style Field',
  description: 'Controls background and text colors for the overall look and feel of the portal.',
  sourceToken: 'fill-surface-default',
  derivedTokens: Object.keys(PORTALS_SURFACE_TOKENS)
};
export const primaryColorSection = {
  id: 'primary-color',
  title: 'Primary Color Field',
  description: 'Primary brand color for the portal',
  sourceToken: 'fill-primary-default',
  derivedTokens: Object.keys(PORTALS_PRIMARY_COLOR_TOKENS)
};
export const secondaryColorSection = {
  id: 'secondary-color',
  title: 'Secondary Color Field',
  description: 'Secondary brand color for the portal',
  sourceToken: 'fill-secondary-default',
  derivedTokens: Object.keys(PORTALS_SECONDARY_COLOR_TOKENS)
};
export const accentColorOneSection = {
  id: 'accent-color-one',
  title: 'Accent Color 1 Field',
  description: 'Accent Color 1 brand color for the portal',
  sourceToken: 'fill-tertiary-default',
  derivedTokens: Object.keys(PORTALS_ACCENT_COLOR_ONE_TOKENS)
};
export const primaryFontSection = {
  id: 'primary-font',
  title: 'Primary Font Field',
  description: 'Controls the font family used for headings throughout the portal.',
  referenceToken: 'heading-300',
  typographyTokens: Object.keys(PORTALS_HEADING_FONT_TOKENS)
};
export const bodyFontSection = {
  id: 'body-font',
  title: 'Body Font Field',
  description: 'Controls the font family used for body text throughout the portal.',
  referenceToken: 'body-100',
  typographyTokens: Object.keys(PORTALS_BODY_FONT_TOKENS)
};
export const THEME_FIELD_SECTIONS = [surfaceSection, primaryColorSection, secondaryColorSection, accentColorOneSection];
export const FONT_SECTIONS = [primaryFontSection, bodyFontSection];